<template>
  <div>
  <initio-panel @submit-handler="submitHandler" :errors="errors" :hide-submit="true">
    <template v-slot:title>
      Confirm your car cover
    </template>
    <template v-slot:sidebar>
      
       <initio-quote-overview location="top" v-bind:quote_premium="quotePremiumRaw" v-bind:quote_premium_adjustment="quotePremiumAdjustmentRaw">
        </initio-quote-overview>
      <br />
      <initio-quote-overview v-on:emitModalMonthlyInsurance="toggleModal('How monthly works')" class="is-hidden-mobile" location="bottom" v-bind:quote_premium="quotePremiumRaw" v-bind:quote_premium_adjustment="quotePremiumAdjustmentRaw">
        </initio-quote-overview>

      <div class="quote_debug is-hidden-mobile" v-if="quoteDebugData.next_period_list">
        <div class="box">
          <h4 class="subtitle is-5">Debug (Re-price next period)</h4>
          <div class="content">
            <ol>
              <li v-for="(item, index)  in quoteDebugData.next_period_list" :key="index">
                <div v-html="item"></div>
              </li>
            </ol>
            <code>
              Input vars
              <ol>
                <li v-for="(item, index)  in quoteDebugData.next_period_list_input" :key="index">
                  {{ index }}: <span v-html="item"></span>
                </li>
              </ol>
            </code>
          </div>
        </div>
      </div>

    </template>
    <template v-slot:form_footer>
      <hr />

      <div class="notification is-info-blue" v-if="quoteDiscountResellerName">
        <strong>Discount applied.</strong> Your {{ quoteDiscountResellerName }} discount has been applied.
      </div>

      <div class="box quote-box" :class="{'is-loading': quoteIsLoading}">
        <SpinnerSvg class="loading-spinner" />
        <div class="columns mt-4 is-centered is-flex border-bottom">
          <div class="column">
            <InlineText
                v-if="quotePremiumAdjustmentRaw > 0"
                label="Adjustment amount"
                tooltip="This is the total additional premium to pay now for the changes to your policy. The amount is pro rated, based on the number of days left in your current insurance period."
            />
            <InlineText
                v-if="quotePremiumAdjustmentRaw <= 0"
                label="Adjustment amount"
                tooltip="This is the total difference in premium to be refunded now for the changes to your policy. The amount is pro rated, based on the number of days left in your current insurance period."
            />
          </div>
          <div class="column is-narrow" v-if="quotePremiumAdjustmentRaw !== null">
            <div class="has-text-right has-text-weight-bold is-size-5">{{ quotePremiumAdjustmentRaw | toCurrency }}</div>
          </div>
        </div>
        <div class="columns mt-4 is-centered is-flex border-bottom" v-if="paymentInterval() === 'monthly'">
          <div class="column">
            <InlineText
                :label="'New ' + paymentInterval() + ' payment'"
                :tooltip="paymentInterval() == 'monthly' ? 'New monthly payment amount may also include an annual premium change if your next payment is the anniversary of your policy' : null"
            />
          </div>
          <div class="column is-narrow has-text-right" v-if="quoteNextPeriodPremiumRaw !== null">
            <div class="has-text-right has-text-weight-bold is-size-5">{{ quoteNextPeriodPremiumRaw | toCurrency }}</div>
          </div>
        </div>
        <div class="columns is-flex">
          <div class="column mt-4 has-text-right" v-if="!quoteErrors">
            <p class="has-text-grey is-size-7 mb-5">Incl GST &amp; Gov. Charges</p>
          </div>
        </div>
        <footer class="box-adjustment">
          <div class="columns is-centered is-multiline">
            <div class="column is-4 mt-4 has-text-centered" v-if="!quoteErrors">
              <button class="button  is-large is-fullwidth has-text-weight-bold" :class="{'is-cta' : !adjustmentAmountUnderThreshold, 'is-static':adjustmentAmountUnderThreshold}" :disabled="adjustmentAmountUnderThreshold">Continue</button>
              <p class="has-text-grey is-size-7 mt-2" v-if="! adjustmentAmountUnderThreshold">
                <span v-if="paymentInterval() === 'monthly'">Credit card payment only</span>
                <span v-if="paymentInterval() === 'yearly'">Credit card, Online EFTPOS or Account2Account</span>
              </p>
              <p class="has-text-danger is-size-7 mt-2" v-if="adjustmentAmountUnderThreshold">Minimum adjustment amount 80c </p>
            </div>
            <div class="column is-4 has-text-centered" v-if="quoteErrors">
              <div class="notification is-danger">
                There was a problem loading the quote, please try again
              </div>
            </div>
          </div>
        </footer>
      </div>

      <payment-breakdown-graph :breakdownsByInterval="quoteBreakdownsByInterval" />


      <div class="quote_debug is-hidden-mobile" v-if="quoteDebugData.alt_list">

        <div class="columns is-multiline">

          <div class="column is-narrow is-6">
            <div class="box">
              <h4 class="subtitle is-5">Debug: Adjustment pricing</h4>
              <div class="content">
                <ol>
                  <li v-for="(item, index)  in quoteDebugData.alt_list" :key="index">
                    <div>{{item.title}}</div>
                    <div v-if="item.is_text">{{ item.single_value}}</div>
                    <div v-if="!item.is_text">{{ parseFloat(item.single_value) | toCurrency }}</div>
                  </li>
                </ol>
              </div>
            </div>
          </div>


          <div class="column is-narrow is-6">
            <div class="box">
              <h4 class="subtitle is-5">Debug: Re-price existing period</h4>
              <div class="content">
                <ol>
                  <li v-for="(item, index)  in quoteDebugData.current_period_list" :key="index">
                    <div v-html="item"></div>
                  </li>
                </ol>
                <code>
                  Input vars
                  <ol>
                    <li v-for="(item, index)  in quoteDebugData.current_period_input" :key="index">
                      {{ index }}: <span v-html="item"></span>
                    </li>
                  </ol>
                </code>
              </div>
            </div>
          </div>

        </div>
      </div>
      <initio-quote-overview
          v-on:emitModalMonthlyInsurance="toggleModal('How monthly works')"
          class="is-visible-mobile"
          location="bottom"
          v-bind:quote_premium="quotePremiumRaw"
          v-bind:quote_premium_adjustment="quotePremiumAdjustmentRaw" />
    </template>
  </initio-panel>
  <modal
      v-if="modalOpen"
      :class="{ 'is-active': modalOpen }"
      v-on:childToParent="toggleModal"
      :title="modalTitle"
  >
    <div v-if="modalTitle === 'How monthly works'">
      <table width="100%" border="0" cellpadding="0" cellspacing="0" class="table">
        <tbody><tr><td>Month to month insurance policy (just like a subscription)</td></tr>
        <tr><td>We automatically renew your policy each month (always insured)</td></tr>
        <tr><td>Your selected credit card is charged with the monthly premium</td></tr>
        <tr><td>We always tell you when we have renewed and charged your card</td></tr>
        <tr><td>You can cancel or change your monthly insurance anytime</td></tr>
        <tr><td>We always tell you what next month's insurance cost will be</td></tr>
        <tr><td>We let you know if your card declines or expires</td></tr>
        </tbody>
      </table>
      <strong>Why does Monthly cost more?</strong>
      <p>With a monthly payment we don't receive all of the money upfront.  This affects how the insurer funds customer claim payments. In addition, there is more cost associated with payment processing as there are a greater number of transactions.</p>
      <p><a class="" href="/how-monthly-insurance-works" target="_blank">Learn more</a></p>
    </div>
    <div v-if="modalTitle === 'How yearly works'">
      <table width="100%" border="0" cellpadding="0" cellspacing="0"  class="table">
        <p>A traditional annual insurance policy:</p>
        <tr><td>Purchase cover for a year in advance (credit card, or 'account 2 account' transfer)</td></tr>
        <tr><td>You can cancel or change your annual insurance anytime</td></tr>
        <tr><td>Next year, we will remind you a month ahead of when the policy is due to renew</td></tr>
        <tr><td>Logging into your initio dashboard will enable you to see the renewal premium</td></tr>
        <tr><td>You can renew the cover directly from within your initio dashboard</td></tr>
        <tr><td>Its an annual contract and the payment will change each year</td></tr>
      </table>
    </div>
    <div v-if="modalTitle === 'Adjustment amount'">
      <table width="100%" border="0" cellpadding="0" cellspacing="0" class="table">
        <tbody><tr><td>Adjustment amount</td></tr>
        </tbody>
      </table>
      <p><a class="" href="/how-monthly-insurance-works" target="_blank">Learn more</a></p>
    </div>
  </modal>
  </div>
</template>

<script>

import InitioPanel from '@/components/initio/InitioPanel.vue'
import InitioQuoteOverview from '@/components/partials/QuoteOverview.vue'
import stepSubmit from '@/mixins/stepSubmit.js'
import SpinnerSvg from '@/components/partials/SpinnerSvg.vue'
import PaymentBreakdownGraph from '@/components/partials/PaymentBreakdownGraph.vue'

import debounce from "lodash.debounce";
import { mapGetters } from 'vuex'
const axios = require("axios");
import cloneDeep from "lodash.clonedeep";

// import VueRouter from 'vue-router'
import { api } from '@/store/store.js';

export default {
  components: {
    InitioPanel,
    InitioQuoteOverview,
    SpinnerSvg,
    PaymentBreakdownGraph
  },
  mixins: [
    stepSubmit
  ],
  methods: {
    submitHandler() {
      let context = this;

      this.$store.commit('updateBackendData', {
        [this.getStep('quote')]: {
            vehicle_quote_premium_raw: this.quotePremiumRaw,
            vehicle_quote_discount_raw: this.quotePremiumDiscountAmountRaw,
            vehicle_quote_adjustment_raw: this.quotePremiumAdjustmentRaw,
            vehicle_quote_next_period_billing_date_sql: this.quoteNextPeriodEffectiveDateSql,
            vehicle_quote_next_period_premium_raw: this.quoteNextPeriodPremiumRaw,
          }
        }
      );

      this.genericSubmitHandler()
        .then(response => {

          if ( response.results.changelist ) {
            this.$store.commit('updateBackendData', {
              'changelist': response.results.changelist
            })
          } else {
            this.$store.commit('updateBackendData', {
              'changelist': []
            })
          }
          
        }, error => {
          console.error("VehicleQuote Handler error", error); // Unsure if we need this or not, remove if not needed
          context.errors = error;
        });
    },

    getQuote:   debounce(function(updatedAnswers) {
      this.quoteIsLoading = true;
      this.quoteErrors = false;
      // console.log(this.sessionId());

      // There is a bit of a delay while the slider component gets ready and returns a value.
      // Just keep the loading icon until we get a vehicle_cover_type
      const cover_type = updatedAnswers[this.getStep('quote')]['vehicle_cover_type'];
      if( ! cover_type ){
        return false;
      }

      // Also keep loading/waiting unless we have a sum_insured that isn't 0 when non TPO
      if( cover_type !== 'third-party-only' && ! updatedAnswers[this.getStep('quote')]['vehicle_sum_insured_amount'] ){
        return false;
      }

      // Also keep loading/waiting if full cover and the vehicle_low_usage question is not answered
      if( cover_type === 'full' ){
        if( !updatedAnswers[this.getStep('quote')]['vehicle_low_usage'] ){
          return false;
        }
      }

     // Handle preventing submitting data when the chosen sum-insured is out-side the valid plate range ( which then fires a out-of-bounds email on backend)
     // This is specifically if they go back and change a plate to a sum_insured outside the price bounds of the first plate
     // There should be a second update where vue formulate kicks in with the updated sum_insured from the slider
     if( cover_type === 'full' || cover_type === 'third-party-fire-theft'  ) {

       const sum_insured = parseInt(updatedAnswers[this.getStep('quote')]['vehicle_sum_insured_amount']);
       const max_low = parseInt(this.answers[this.getStep('quote')].vehicle_price_low);
       const max_high = parseInt(this.answers[this.getStep('quote')].vehicle_price_high);

       if (sum_insured < max_low || sum_insured > max_high) {
         //   console.log('sum_insured', sum_insured, 'max_low', max_low, 'max_high', max_high )
         // console.log('cancelled quote request since invalid sum_insured within params');
         return false;
       }
     }

      // All the data should now be ready to provide to the quote API ( and prevent mismatch backend errors on the quote handler )

      // Cancel any existing out-going requests ( so they don't pile up, or change the price on different request params )
      this.axiosCancelTokenSource.cancel();

      // Request a quote
      axios.post(`${api.url + api.version}vehicle/alt/premium/${this.sessionId()}`, { cancelToken: this.axiosCancelTokenSource.token, ...updatedAnswers[this.getStep('quote')]})
          .then(response => {
            this.quoteIsLoading = false;
            this.quoteDebugData = {};
            this.quoteBreakdownsByInterval = {};
            if( response.data.results && response.data.results.total_cost_inc_gst !== undefined ){
              const results = response.data.results;
              this.quotePremiumRaw = results.total_cost_inc_gst;
              this.quotePremiumDiscountAmountRaw = results.discount_value_inc_gst ? results.discount_value_inc_gst : false;
              this.quotePremiumAdjustmentRaw = results.adjustment_amount;
              this.quoteDiscountResellerName = results.discount_reseller_name ? results.discount_reseller_name : '';
              this.quoteNextPeriodEffectiveDateSql = results.next_period_effective_date_sql;
              this.quoteNextPeriodPremiumRaw = results.next_period_premium_amount;
              this.quoteErrors = false;

              // Kinda gross way to handle the breakdown data
              if( results.payment_interval === 'yearly'){
                this.quoteBreakdownsByInterval = {
                  yearly: results.adjustment_amount_payment_breakdown,
                }
              } else if( results.payment_interval === 'monthly' ) {
                this.quoteBreakdownsByInterval = {
                  monthly: results.adjustment_amount_payment_breakdown,
                }
              }

              // Re-quote original policy period
              if( results.debug ){
                this.quoteDebugData = results.debug;
              }
            } else {
              // console.log(response.data);
              this.quoteErrors = true;
            }
          }, error => {
            console.error(error, "Get quote error");
            this.quoteErrors = true;
          });

    }, 200), // Add delay before requesting quote, needs about 180 for the vue elements to property show/hide/update
    toggleModal: function (title='') {
      this.modalTitle = title;
      this.modalOpen = ! this.modalOpen;
    }
  },
  watch: {
    // Update the store with the local component state on change with debounce
    answers (updatedAnswers) {
      // debounce here ?
      this.getQuote(updatedAnswers);
    },
  },
  mounted () {

    this.$store.dispatch('getSchema', 'alt/vehicle-quote' )
      .then(response => {
        this.$store.commit('updateSchema', response);
      })

    this.getQuote(this.answers);
  },
  data () {
    return {
      modalOpen: false,
      modalTitle: '',
      errors: [],
      schema: [],
      quoteIsLoading: true,
      quoteErrors: false,
      quotePremiumRaw: null,
      quotePremiumDiscountAmountRaw: null,
      quotePremiumAdjustmentRaw: null,
      quoteDiscountResellerName: null,
      quoteNextPeriodEffectiveDateSql: null,
      quoteNextPeriodPremiumRaw: null,
      quoteDebugData: {},
      axiosCancelTokenSource:  axios.CancelToken.source(),
      quoteBreakdownsByInterval: {},
    }
  },
  computed: {
    ...mapGetters({
      answers: 'flattenedAnswers',
      answerLabel: 'getAnswerLabel',
      sessionId: 'getSessionId',
      isLoggedIn: 'isLoggedIn',
      getStep: 'getStep',
      paymentInterval: 'getPaymentInterval'
    }),
    adjustmentAmountUnderThreshold: function(){
      return (this.quotePremiumAdjustmentRaw > 0 && this.quotePremiumAdjustmentRaw < 0.80);
    }
  },
}

</script>

<style scoped lang="scss">

  .quote-box {
    position: relative;
    padding-bottom: 0;
    padding-top: 0;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.07);
    border-radius: 0;

    header {
      background: $initio-green;
      color: white;
      padding: 10px;
      border-bottom: 1px solid $light-grey;
      font-size: 10px;
      //border-top-left-radius: 5px;
      //border-top-right-radius: 5px;
    }

    &:after {
      transition: 200ms ease-in-out;
      content: '';
      display: block;
      position: absolute;
      left:0;
      right:0;
      top:0;
      bottom:0;
      background: white;
      opacity: 0;
      pointer-events: none;
    }

    .title {
      font-size:2.25rem;
    }

    .is-cta {
      filter: drop-shadow(0px 2px 11px rgba(39, 39, 39, 0.243772));
    }
  }
  .quote-box.is-loading {
    &:after {
      opacity: 0.4;
      pointer-events: auto;
    }
    .loading-spinner {
      opacity: 1;
    }
  }

  .loading-spinner {
    position: absolute;
    top: 80px;
    right: 50%;
    margin-right: -20px;
    z-index: 15;
    transition: 200ms ease-in-out;
    opacity: 0;
  }

  header, footer {
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  footer {
    //background:linear-gradient(red, yellow);
    min-height:30px;
    box-shadow: inset 0 7px 9px -7px rgba(0,0,0,0.4);
    box-shadow: inset 0 30px 30px -30px rgba(0, 0, 0, 0.07);
    border-top: 1px solid #EEEEEE;
    padding: 2rem;
  }
  .border-bottom {
    border-bottom: 1px solid #EEEEEE;
  }
  .border-top-bottom {
    border-top: 1px solid #EEEEEE;
    border-bottom: 1px solid #EEEEEE;
  }

  .box-adjustment {
    padding:0.5rem;
  }

  .quote-box__monthly-benefit {
    font-weight: 900;
    font-size: 12px;
  }

  .how-monthly-works-icon-link {
    background: $light-grey;
    height: 20px;
    width: 20px;
    color: white;
    text-transform: none;
    font-weight: normal;
    margin-left: 5px;
    text-align: center;
    display: inline-block;
    border-radius: 50%;
    line-height: 20px;
    &:hover {
      background: #00A7FF;
      color: white;
    }
  }

  .quote-box__monthly-benefit {
    border-bottom: 1px solid $light-grey;
    padding: 8px;
  }

  .quote_debug {
    margin-top: 20px;
    position:relative;
    z-index:30;

    > .box {
      background:rgba(255,255,255,0.5);
    }

    ol li {
      margin-bottom: 15px;
      font-size: 14px;
    }
  }
</style>
<style lang="scss">

  .is-visible-mobile {
    display:none;

    @include mobile() {
      display: block;
    }

  }
</style>